import React from "react";

function Positioning() {
  return (
    <section className="overflow-hidden bg-[#f8faf9] section-spacing">
      <div className="section-container">
        {/* Label */}
        <p className="font-jakarta text-[11px] sm:text-[12px] font-medium tracking-[0.34em] text-[var(--hero-green)] uppercase mb-2.5">
          POSITIONING
        </p>

        {/* Big Statement */}
        <h2 className="mt-4 font-bricolage text-[26px] sm:text-[34px] md:text-[38px] lg:text-[42px] font-medium leading-[1.25] tracking-[-0.8px] text-[#111827]">
          Finverse funds loans directly and also runs a neutral marketplace to partner NBFCs and banks. DSAs and partner lenders are equal sides of that marketplace.
        </h2>
      </div>
    </section>
  );
}

export default Positioning;
